/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { isEqual, noop } from 'lodash'
import { useRef, useEffect } from 'react'

export function useDidMount(
  callback: () => (void | Promise<void>) | (() => void | Promise<void>),
  watch?: any[]
) {
  const didMount = useRef<boolean>(false)
  const prev = useRef(watch)

  useEffect(() => {
    const changed = !isEqual(prev.current, watch)

    if (!didMount.current || changed) {
      prev.current = watch
      didMount.current = true
      const a = callback()

      if (typeof a === 'function') {
        return a
      }
    }

    return noop
  }, [watch])
}
